import { SVGProps } from 'react'
const SvgChevronIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M2 8.54545L6.28571 14L16 4'
      stroke={props.color ?? '#69AE97'}
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
export default SvgChevronIcon
